import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation } from 'react-query';

interface ToggleLeadNotificationsForCustomer {
  customerId: number;
  leadsNotificationsAccess: number;
}

export const toggleLeadNotifications = async (
  data: ToggleLeadNotificationsForCustomer
) => {
  const response = await EXPRESS_API.post(
    `/crm/vinsolutions/${data.customerId}/toggle-leads-notifications`,
    {
      leadsNotificationsAccess: data.leadsNotificationsAccess,
    }
  );
  return response.data;
};

export const useLeadNotificationsMutation = () => {
  return useMutation(toggleLeadNotifications, {
    onError: error => {
      console.log(error);
    },
  });
};
